import { useEffect, useState } from 'react';
import './ChatContent.less';
import ClawChatHeader from './chat/Header';
import ChatContent from './chat/Content';
import useClawWsStore from '@src/stores/useClawWsStore';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { getBaseKeyModule } from '@src/hooks/useClawWs';

export const ClawChatContent = () => {
  const [shareMode, setShareMode] = useState(false);
  const currentSessionKey = useClawWsStore((s) => s.currentSessionKey);
  const sessions = useClawWsStore((s) => s.sessions);
  const { sessionKey: sessionKeyFromUrl } = useParams<{ sessionKey?: string }>();
  const hasValidSessionFromUrl = useMemo(() => {
    if (!sessionKeyFromUrl) return false;
    return sessions.some((session) => {
      if (!session?.key) return false;
      return getBaseKeyModule(session.key) === sessionKeyFromUrl;
    });
  }, [sessionKeyFromUrl, sessions]);

  useEffect(() => {
    setShareMode(false);
  }, [currentSessionKey]);

  return (
    <div className="claw-chat-content">
      <ClawChatHeader
        shareMode={shareMode}
        onShare={() => setShareMode(true)}
        showShareButton={Boolean(currentSessionKey || hasValidSessionFromUrl)}
      />
      <div className="claw-chat-content__body">
        <div className="claw-chat-content__main">
          <ChatContent
            shareMode={shareMode}
            onExitShare={() => setShareMode(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default ClawChatContent;
